export default __webpack_public_path__ + "static/media/menu.3c0f5b25.svg";